import { MainContentArea, ContentHeader } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useState } from "react";
//import { AddHoopsSupplierProductButton } from "../../components/suppliers/AddHoopsSupplierProductButton";
//import { AddThreadsSupplierProductButton } from "../../components/suppliers/AddThreadsSupplierProductButton";
import { useRolesContext } from "../../hooks/roles/useRolesContext";
import { ManageSupplierProductsList } from "../../components/supplierproducts/ManageSupplierProductsList";
import { AddSupplierProductButton } from "../../components/supplierproducts/AddSupplierProductButton";

// To Do: Add BreadCrum
// Add Translation
export const ManageSupplierProducts: React.FC = () => {
  const { t } = useTranslation();
  const [isSupplierProductAddDrawerOpen, setIsSupplierProductAddDrawerOpen] = useState<boolean>(false);
  const [supplierIdToUpdate] = useState<string>("");
  const { roles } = useRolesContext();

  const setOpenSupplierProductDrawerAndSettingValuesFunction = (drawerOpen: boolean) => {
    setOpenSupplierProductAddDrawerFunction(drawerOpen);

  }

  const setOpenSupplierProductAddDrawerFunction = (drawerOpen: boolean) => {
    setIsSupplierProductAddDrawerOpen(drawerOpen);
  }



  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("supplierproducts.basic.title")}
          extra={
            <>
              {
                roles.SYSTEM_SUPPLIERPRODUCTS_CREATE && <AddSupplierProductButton
                  setIsAddSupplierProductDrawerOpenAction={setOpenSupplierProductDrawerAndSettingValuesFunction}

                />
              }
              {/* {
               roles.SYSTEM_SUPPLIERPRODUCTS_CREATE && <AddThreadsSupplierProductButton
                  setIsAddThreadsSupplierProductDrawerOpenAction={setOpenSupplierProductDrawerAndSettingValuesFunction}
                />
              }  */}
            </>
          }
        />

      }
    >

      <ManageSupplierProductsList
        supplierIdToUpdate={supplierIdToUpdate}

        isSupplierProductAddDrawerOpen={isSupplierProductAddDrawerOpen}
        setSupplierProductAddDrawerOpenFunction={setOpenSupplierProductAddDrawerFunction} />
    </MainContentArea>
  );
};
